import React from "react";
import Skeleton from "@mui/material/Skeleton";

const widths = [96, 132, 116, 148, 124, 104, 138, 118, 156, 128, 112, 142, 122, 134, 108];

function TargetTypeOptionsSkeleton() {
    return (
        <ul className="addrules-target-grid-v2 addrules-target-grid-skeleton-v2" aria-hidden="true">
            {widths.map((width, index) => (
                <li className="addrules-target-item-v2" key={index}>
                    <Skeleton variant="circular" width={18} height={18} />
                    <Skeleton variant="text" width={width} height={24} />
                </li>
            ))}
        </ul>
    );
}

export default TargetTypeOptionsSkeleton;
